module.exports = __webpack_public_path__ + "img/development-during-recession-top.ad0349de.webp";